import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { CardContent } from '@stepstone-genesis/components';
import { GradientBackground } from './GradientBackground.js';
import { ContentWrapper } from './ContentWrapper.js';
import { DefaultContent } from './DefaultContent.js';
import { LoggedInContent } from './LoggedInContent.js';
import { useAppSelector } from '../../../hooks/redux/index.js';
import { twoStepActiveStateSelector } from '../../../forms/TwoStepLoginRegistration/twoStepLoginRegistrationSlice.js';
import { FadeTransition } from './FadeTransition.js';
export const LeftSideContent = () => {
    // const isLoggedInWithApple = useAppSelector(emailUpdateRequiredSelector);
    // TODO: think which selector to use here
    const isAppleUpdateEmailView = useAppSelector(twoStepActiveStateSelector) === 'appleUpdateEmail';
    return (_jsxs(CardContent, { sx: {
            padding: 'spaceNone',
            width: ['100%', '48.5%'],
            position: 'relative',
            overflow: 'hidden',
            borderRadius: 'radiusL2',
            minHeight: ['auto', '93vh'],
        }, children: [_jsx(GradientBackground, {}), _jsx(ContentWrapper, { children: isAppleUpdateEmailView ? (_jsx(FadeTransition, { transitionKey: "logged-in-content", children: _jsx(LoggedInContent, {}) })) : (_jsx(FadeTransition, { transitionKey: "default-content", children: _jsx(DefaultContent, {}) })) })] }));
};
//# sourceMappingURL=LeftSideContent.js.map